import axiosInstance from '../axiosInterceptor/axiosInstance'

const createSeasonTeamPlayer = async (orgId, playerData) => {
  const url = `v1/orgs/${orgId}/season-team-players/create`
  const response = await axiosInstance.post(url, playerData)
  return response?.data
}

export default createSeasonTeamPlayer
